// extracted by mini-css-extract-plugin
module.exports = {"bannerSection":"style_bannerSection__dmw88","formBlock":"style_formBlock__a0_Vu","contactInfo":"style_contactInfo__Roj5W","socialMenu":"style_socialMenu__lbL8b"};